import { css } from "@emotion/react";
import settings from "@settings";

export const templateContainer = settings.mq({
    width: '100vh',
    height: '100vw',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch'
})

export const leftContent = settings.mq({
    display: ['none', 'none', 'none'],
    width: ['33%', '25%', '25%'],
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: settings.sizes.medium,
    overflow: 'visible',
    borderRight: `1px solid ${settings.colors.grey}`,
    'h1': {
        marginBottom: settings.sizes.medium,
    },
    'a': {
        fontSize: settings.fontSize.small,
        textTransform: 'uppercase',
    }
})

export const rightContent = settings.mq({
    position: 'relative',
    width: ['100%', '100%', '100%'],
    overflowY: 'scroll',
    scrollBehavior: 'smooth',
    'h3': {
        marginTop: '36px',
    }
})

export const typeHeader = settings.mq({
    fontFamily: 'Coco Sharp',
    fontWeight: 700,
    fontSize: settings.fontSize.medium,
    letterSpacing: '2px',
})

export const typeText = settings.mq({
    fontFamily: 'Coco Sharp',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: settings.fontSize.tiny,
    letterSpacing: '2px',
    color: settings.colors.grey,
})

export const headline = css({
    position: 'fixed',
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 4
})

export const templateLinkStyle = (isActive: boolean) => settings.mq({
    fontFamily: 'Coco Sharp',
    fontSize: `${settings.fontSize.large} !important`,
    fontWeight: isActive ? 700 : 500,
    textDecoration: 'none',
    color: isActive ? settings.colors.dark : settings.colors.grey,
    gap: settings.sizes.medium,
    transition: 'color 0.3s ease, font-weight 0.3s ease',
    lineHeight: '30px',
    verticalAlign: 'center',
    textTransform: 'none !important'
});

export const pageStateText = settings.mq({
    fontFamily: 'Coco Sharp',
    fontSize: settings.fontSize.tiny,
    left: '12px',
    fontWeight: 500,
    textDecoration: 'none',
    color: settings.colors.dark,
    transition: 'color 0.3s ease, font-weight 0.3s ease',
    lineHeight: 1,
    verticalAlign: 'center',
    textTransform: 'none !important',
    position: 'absolute',
    display: 'inline-block'
})

export const templateFooterContainer = css({
    borderTop: `1px solid ${settings.colors.grey}`,
    padding: settings.padding.medium
})

export const templateHeaderContainer = css({
    borderBottom: `1px solid ${settings.colors.grey}`,
    padding: settings.padding.medium,
    height: '60px' 
})

export const templateNavigationContainer = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: settings.sizes.medium,
})

export const templateNavigationElement = css({
    cursor: 'pointer',
    borderBottom: '2px solid transparent',
    ':hover': {
        borderBottom: `2px solid ${settings.colors.dark}`,
        color: settings.colors.dark
    }
})

export const templateContentContainer = css({
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    scrollBehavior: 'smooth',
    width: 'fit-content',
    gap: 0,
    overflow: 'hidden',
    zIndex: 2
})

export const largeHeadline = settings.mq({
    fontWeight: '500 !important',
    textTransform: ['none', 'none', 'uppercase !important'],
    fontSize: ['30px', '36px', '84px !important']
})

export const nextPageContainer = css({
    zIndex: 1,
    position: 'fixed',
    bottom: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '540px',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
})

export const mobileContentContainer = css({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    scrollBehavior: 'smooth',
    width: '100%',
    gap: 0,
    overflow: 'auto',
    zIndex: 2
})